const buildGraph = (paths, allFields) => {
  const nodeIndex = /* @__PURE__ */ new Map();
  const nodes = [];
  const indexOf = (label, stage, originalValue) => {
    const existing = nodeIndex.get(label);
    if (existing !== void 0) return existing;
    const idx = nodes.length;
    nodeIndex.set(label, idx);
    nodes.push({ label, field: allFields[stage], value: originalValue, degree: 0 });
    return idx;
  };
  const edgeAgg = /* @__PURE__ */ new Map();
  paths.forEach((path) => {
    for (let i = 0; i < path.keys.length - 1; i += 1) {
      const sourceLabel = String(path.keys[i]);
      const targetLabel = String(path.keys[i + 1]);
      const source = indexOf(sourceLabel, i, path.keys[i]);
      const target = indexOf(targetLabel, i + 1, path.keys[i + 1]);
      const edgeKey = `${source}\0${target}`;
      const existing = edgeAgg.get(edgeKey);
      if (existing) {
        existing.value += path.value;
      } else {
        edgeAgg.set(edgeKey, { source, target, value: path.value });
        nodes[source].degree += 1;
        nodes[target].degree += 1;
      }
    }
  });
  return { nodes, edges: Array.from(edgeAgg.values()) };
};
export default buildGraph;
